import { jsx as t, jsxs as p } from "react/jsx-runtime";
import * as o from "@radix-ui/react-tooltip";
import * as d from "react";
import { cn as f } from "../../utils.js";
const s = d.forwardRef(({ title: e, ...i }, a) => /* @__PURE__ */ t(o.Trigger, { title: e, ref: a, ...i }));
s.displayName = o.Trigger.displayName;
const l = d.forwardRef(({ className: e, sideOffset: i = 4, ...a }, r) => /* @__PURE__ */ t(
  o.Content,
  {
    ref: r,
    sideOffset: i,
    className: f(
      "z-tooltip max-w-[300px] overflow-hidden rounded-md border bg-onSurface-900 px-1.25 py-0.75 text-sm text-white shadow-md animate-in fade-in-0 zoom-in-95 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      e
    ),
    ...a
  }
));
l.displayName = o.Content.displayName;
const c = ({
  children: e,
  content: i,
  className: a,
  delayDuration: r = 0,
  enabled: m = !0,
  ...n
}) => /* @__PURE__ */ t(o.TooltipProvider, { children: /* @__PURE__ */ p(o.Tooltip, { delayDuration: r, ...n, children: [
  /* @__PURE__ */ t(s, { asChild: !0, children: /* @__PURE__ */ t("div", { children: e }) }),
  m && /* @__PURE__ */ t(l, { className: a, children: i })
] }) });
c.displayName = "Tooltip";
export {
  c as Tooltip
};
